import ConfirmMenuItem from './ConfirmMenuItem'

export default ConfirmMenuItem
